var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageListCheckmarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.79 35.4499V119.56C108.791 120.25 108.656 120.934 108.393 121.572C108.13 122.21 107.743 122.79 107.256 123.279C106.768 123.767 106.189 124.155 105.551 124.419C104.914 124.684 104.23 124.82 103.54 124.82H28.6399C27.2457 124.817 25.9093 124.262 24.9234 123.276C23.9376 122.29 23.3825 120.954 23.3799 119.56V22.1699C23.3852 20.7765 23.941 19.4417 24.9263 18.4564C25.9116 17.471 27.2465 16.9152 28.6399 16.9099H91.0999L108.79 35.4499Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.47 75.6201L144.32 78.4701L123.17 99.6201L113.84 90.2901L116.71 87.4401L123.17 93.9001L141.47 75.6201Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1499 56.48C48.309 56.48 50.8699 53.9191 50.8699 50.76C50.8699 47.601 48.309 45.04 45.1499 45.04C41.9909 45.04 39.4299 47.601 39.4299 50.76C39.4299 53.9191 41.9909 56.48 45.1499 56.48Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1499 82.21C48.309 82.21 50.8699 79.6491 50.8699 76.49C50.8699 73.331 48.309 70.77 45.1499 70.77C41.9909 70.77 39.4299 73.331 39.4299 76.49C39.4299 79.6491 41.9909 82.21 45.1499 82.21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1499 107.94C48.309 107.94 50.8699 105.379 50.8699 102.22C50.8699 99.0609 48.309 96.5 45.1499 96.5C41.9909 96.5 39.4299 99.0609 39.4299 102.22C39.4299 105.379 41.9909 107.94 45.1499 107.94Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8399 129.43L95.5499 132.7C95.492 133.387 95.299 134.056 94.982 134.669C94.6649 135.281 94.2301 135.825 93.7024 136.269C93.1747 136.713 92.5645 137.049 91.9068 137.257C91.2492 137.465 90.557 137.54 89.8699 137.48L15.2499 131C13.8631 130.875 12.5819 130.207 11.6863 129.141C10.7907 128.075 10.3534 126.698 10.4699 125.31L18.9599 28.3101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 35.46H91.3699V15.23",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16.78C39 15.6449 39.4509 14.5562 40.2536 13.7536C41.0562 12.9509 42.1449 12.5 43.28 12.5C44.4151 12.5 45.5038 12.9509 46.3064 13.7536C47.1091 14.5562 47.56 15.6449 47.56 16.78V33.23C47.56 33.7976 47.3345 34.3419 46.9332 34.7432C46.5319 35.1445 45.9876 35.37 45.42 35.37C44.8524 35.37 44.3081 35.1445 43.9068 34.7432C43.5055 34.3419 43.28 33.7976 43.28 33.23V22.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47.9299H89.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55.73H81.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58 73.6599H89.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81.46H70.58",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99.3899H89.17",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58 107.2H81.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.74 86.79C143.985 88.0722 144.109 89.3746 144.11 90.68C144.104 95.1319 142.613 99.4545 139.873 102.963C137.133 106.472 133.3 108.966 128.982 110.051C124.665 111.135 120.109 110.748 116.036 108.951C111.963 107.154 108.606 104.049 106.497 100.128C104.388 96.2079 103.647 91.6957 104.392 87.3066C105.137 82.9175 107.325 78.9024 110.61 75.8973C113.894 72.8923 118.087 71.0689 122.525 70.7162C126.963 70.3635 131.392 71.5015 135.11 73.95",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageListCheckmarkGrey);
export default __webpack_public_path__ + "static/media/page_list_checkmark_grey.9621e9a83038259cba597de2f34787b6.svg";
export { ForwardRef as ReactComponent };